import { z } from 'zod';

export const websiteValidator = (_shape?: z.ZodTypeAny) =>
	z
		.string()
		.nullish()
		.transform(v => v?.trim() ?? '')
		.pipe(
			z.string().transform((val, ctx) => {
				if (val === '') return val;

				let finalUrl = val;
				// Auto-prepend https:// if missing
				if (!/^https?:\/\//i.test(val)) {
					finalUrl = `https://${val}`;
				}

				try {
					const url = new URL(finalUrl);

					// Ensure it actually looks like a domain (has a dot) - stops random words like "anything" from passing as "https://anything"
					if (
						!['http:', 'https:'].includes(url.protocol) ||
						!url.hostname.includes('.')
					) {
						ctx.addIssue({
							code: 'custom',
							message: 'Invalid website URL'
						});
						return z.NEVER;
					}

					return finalUrl;
				} catch {
					ctx.addIssue({
						code: 'custom',
						message: 'Invalid website URL'
					});
					return z.NEVER;
				}
			})
		);
